import type { ExtensionsConfigOptions } from '../../types';

export const extConfig: ExtensionsConfigOptions = {
  bold: true,
  italic: true,
  strikethrough: true,
  underline: true,
  bulletList: true,
  orderedList: true,
  horizontalRuler: true,
  link: true,
  emote: true,
  gif: {
    defaultWidth: 900,
    canAlign: true,
    defaultAlignment: 'center',
  },
  deviation: {
    defaultWidth: 900,
    maxWidth: 900,
    canAlign: true,
    canLink: true,
  },
  deviationThumb: {
    defaultWidth: 150,
    canLink: true,
    maxHeight: 600,
    maxWidth: 780,
  },
  allowUploads: true,
  daVideo: {
    canAlign: true,
    defaultWidth: 900,
    defaultHeight: 506,
  },
  gallery: {
    maxWidth: 900,
    defaultWidth: 900,
    defaultAlignment: 'center',
    defaultGridItemWidth: 235,
    defaultGridItemHeight: 235,
    defaultLayout: 'grid',
    defaultTorpedoRowHeight: 150,
    defaultLayoutSpacing: 8,
    canLink: true,
  },
  anchor: true,
  spinner: true,
  blockDragging: true,
  blockquote: true,
  heading: true,
  hashtag: true,
  mention: true,
  paste: true,
  textAlignment: true,
  textColor: false,
  textFont: false,
  textHighlight: false,
  history: true,
  indent: {
    captureTab: true,
  },
  muro: false,
  characterCount: false,
};
